import InnerComponent from '@Components/Admin/Integration';
import orgContainer from '@Components/AppContainer';

const IntegrationPage = () => ((orgContainer(InnerComponent)));
export default IntegrationPage;
